// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"77edfc4a","70":"6cb0267e","71":"87959abf","195":"b8ef5f74","293":"72c0937e","349":"aad7b08a","360":"804374f8","419":"0b94cc9e","606":"20b5474f","621":"ee625e38","870":"a3440ccd"}[chunkId] + ".chunk.css";
};